var r = /* @__PURE__ */ ((a) => (a.workspaceAdmin = "role_admin", a.workspaceAssistant = "role_assistant", a))(r || {});
export {
  r as UserWorkspaceRolesEnum
};
